export const DeviceIcon = {
  alarm: 'lock', // CHANGE
  audio: 'sound', // CHANGE
  bulb: 'bulb', // CHANGE
  cameratvcc: 'camera', // CHANGE
  carichi: 'load', // CHANGE
  carichi2: 'load', // CHANGE
  citofonia: 'derivate', // CHANGE
  tapparella: 'device-tapparella', // CHANGE
  termo: 'termo', // CHANGE
  timers: 'timers', // CHANGE
  virtualdevice: 'input-output', // CHANGE
  automaticDoor0: 'device-automaticdoor', // CHANGE
  automaticDoor1: 'device-automaticdoor', // CHANGE
  barrier0: 'device-barrier', // CHANGE
  barrier1: 'device-barrier', //  CHANGE
  garage: 'device-garage', // CHANGE
  Gateway: 'device-gateway', // CHANGE
  iors485Integrated: 'input-output', // CHANGE
  ipCam: 'camera', // CHANGE
  shutter0: 'device-shutter', // CHANGE
  shutter1: 'device-shutter', // CHANGE
  shutter: 'device-shutter', // CHANGE
  slidingGate0: 'device-slidinggate', // CHANGE
  slidingGate1: 'device-slidinggate', // CHANGE
  swingGate0: 'device-swinggate', // CHANGE
  swingGate1: 'device-swinggate', // CHANGE
  SwingGateVirtual: 'device-swinggate', // CHANGE
  turnStile1: 'device-turnstile', // CHANGE
  gatewayDomotic: 'gateway-domotic',
  gatewayIntercoms: 'derivate', // CHANGE
  gatewaySecurity: 'gateway-security',
  gatewayThermostat: 'gateway-thermostat',
  Rele: 'rele', // CHANGE
  qbe: 'device-gateway', // CHANGE
  rbe: 'device-rbe', // CHANGE
  // OLD VERSION ICON
  /*0: 'gateway-domotic', // ETI/DOMO
  1: 'gateway-security', // PXGPRS
  2: 'device-gateway-ethernet', // 001UR042 CHANGE
  3: 'gateway-domotic', // ETI DOMO XIP
  4: 'gateway-domotic', // ETI MINISER XIP
  5: 'gateway-domotic', // ETI SER XIP
  6: 'gateway-domotic', // DCV IP
  7: 'termo', // TH500 // CHANGE
  8: 'termo', // TH800 // CHANGE
  9: 'device-gateway-gsm', // RGSM001 CHANGE
  10: 'device-subgateway', // RSLV001 CHANGE
  11: 'device-gateway-ethernet', // RETH001 CHANGE
  12: 'device-gateway-gsm', // RGSM001S CHANGE
  13: 'termo', //THONE // CHANGE
  14: 'device-gateway-gsm', // Gateway 4G radio
  15: 'device-gateway', // QBEDFSB1 CHANGE
  16: 'device-gateway', // QBEDFMB3
  17: 'device-gateway-gsm', // Gateway 4G standalone
  18: 'device-gateway', // QBEMFSB2 CHANGE
  19: 'gateway-security', // CENTRALE SICUREZZA PXC2
  20: 'termo', // TH700 // CHANGE
  21: 'input-output', // Virtual device CHANGE
  22: 'device-camekey', // CAMEKEY SLAVE CHANGE
  23: 'device-camekey', // CAMEKEY GATEWAY CHANGE
  24: '', // Inputs
  25: '', // Outputs
  26: '', // Inputs/Outputs
  27: 'derivate', // Mtma  CHANGE
  28: 'derivate', // XTS7 IP CHANGE
  29: 'derivate', // PLXWIFI CHANGE
  30: 'derivate', // MTMV/IP CHANGE
  31: 'derivate', // XTS5 CHANGE
  32: 'derivate', // XVP CHANGE
  33: 'derivate', // XTS7 CHANGE
  34: 'derivate', // PLXIPWIFI CHANGE
  51: 'device-barrier', // GARD4EZ CHANGE
  52: 'device-barrier', // G500 CHANGE
  53: 'device-barrier', // GARDPT CHANGE
  54: 'device-barrier', // GARDPX CHANGE
  55: 'device-barrier', // GARD8EZ CHANGE
  56: 'device-garage', // VER PLUS CHANGE
  57: 'input-output', // IORS485 // CHANGE
  58: 'device-rbe', // RBE 4 CHANGE
  59: 'device-tapparella', // VOILA' CHANGE
  60: 'device-slidinggate', // BXV CHANGE
  61: 'device-slidinggate', // BXV Tall CHANGE
  62: 'device-slidinggate', // BK CHANGE
  63: 'device-slidinggate', // BXV Quick CHANGE
  64: 'device-slidinggate', // BKV CHANGE
  65: 'device-slidinggate', // BX CHANGE
  66: 'device-swinggate', // FERNI (230V) CHANGE
  67: 'device-swinggate', // FERNI (24V) CHANGE
  68: 'device-swinggate', // FAST40 (230V) CHANGE
  69: 'device-swinggate', // KRONO CHANGE
  70: 'device-swinggate', // FROG J CHANGE
  71: 'device-swinggate', // FROG (230V) CHANGE
  72: 'device-swinggate', // FROG (24V) CHANGE
  73: 'device-swinggate', // MYTO CHANGE
  74: 'device-swinggate', // SuperFrog CHANGE
  75: 'device-swinggate', // FAST40 (24V) CHANGE
  76: 'device-swinggate', // F4000 (24V) CHANGE
  77: 'device-swinggate', // AXI CHANGE
  78: 'device-swinggate', // FTX CHANGE
  79: 'device-swinggate', // AMICO (24V) CHANGE
  80: 'device-swinggate', // AXO (230V) CHANGE
  81: 'device-swinggate', // AXO (24V) CHANGE
  82: 'device-swinggate', // ATI (230V) CHANGE
  83: 'device-swinggate', // F4000 (230V) CHANGE
  84: 'device-swinggate', // FROG PLUS CHANGE
  85: 'device-turnstile', // STILE ONE CHANGE
  86: 'device-turnstile', // XVIA CHANGE
  87: 'device-turnstile', // SALOON40 CHANGE
  88: 'device-turnstile', // WING 40 CHANGE
  89: 'device-swinggate', // CHANGE
  90: 'device-swinggate', // CHANGE
  91: 'device-barrier', // CHANGE
  92: 'device-barrier', // CHANGE
  93: 'device-swinggate', // CHANGE
  94: 'device-swinggate', // CHANGE
  95: 'device-swinggate', // CHANGE
  96: 'device-swinggate', // CHANGE
  97: 'device-swinggate', // CHANGE
  98: 'device-swinggate', // CHANGE
  99: 'device-swinggate', // CHANGE
  100: 'device-swinggate', // CHANGE
  101: 'device-swinggate', // CHANGE
  102: 'device-swinggate', // CHANGE
  103: 'device-swinggate', // CHANGE
  104: 'device-swinggate', // CHANGE
  105: 'device-swinggate', // CHANGE
  106: 'device-swinggate', // CHANGE
  107: 'device-swinggate', // CHANGE
  108: 'device-swinggate', // CHANGE
  109: 'device-swinggate', // CHANGE
  110: 'device-swinggate', // CHANGE
  111: 'device-slidinggate', // CHANGE
  112: 'device-slidinggate', // CHANGE
  113: 'device-swinggate', // CHANGE
  114: 'device-barrier', // CHANGE
  115: 'device-swinggate', // CHANGE
  116: 'device-swinggate', // CHANGE
  117: 'device-swinggate', // CHANGE
  118: 'device-swinggate', // CHANGE
  119: 'device-swinggate', // CHANGE
  120: 'device-swinggate', // CHANGE
  121: 'device-swinggate', // CHANGE
  122: 'device-swinggate', // CHANGE
  123: 'device-swinggate', // CHANGE
  124: 'device-swinggate', // CHANGE
  125: 'device-swinggate', // CHANGE
  126: 'device-swinggate', // CHANGE
  127: 'device-swinggate', // CHANGE
  128: 'device-turnstile', // CHANGE
  129: 'device-slidinggate', // CHANGE
  130: 'device-barrier', // CHANGE
  131: 'device-rbe', // RBE 24/230 CHANGE
  132: 'device-shutter', // C-BX
  133: 'device-shutter', // C-BXK
  134: 'device-swinggate', // FROG (230V)
  135: 'device-swinggate', // KRONO
  136: 'device-swinggate', // ATI (230V)
  137: 'device-swinggate', // ATS
  235: 'device-garage', // CHANGE
  241: 'device-rbe', // RBE230 CHANGE
  270: 'device-rbe', // RBE4030 CHANGE
  278: 'device-slidinggate', //BXV06AGE CHANGE
  314: 'device-rbe', // RBE24 CHANGE
  366: 'device-slidinggate', //BXV04AGE CHANGE
  425: 'device-rbe', // RBE4230 CHANGE
  448: 'device-garage', // CHANGE
  969: 'device-swinggate', // ZLX230S
  970: 'device-swinggate', // ZLX230M
  971: 'device-barrier', // ZL392D
  972: 'device-rbe', // RBE GEN_RBE24230 CHANGE
  973: 'device-barrier', // ZN7D
  974: 'device-slidinggate', // ZBB3
  975: 'device-barrier', // ZL392C
  976: 'device-slidinggate', // ZN8REV
  977: 'input-output',// GEN_IORS485 CHANGE
  978: 'device-rbe', // GEN_RBE4 CHANGE
  979: 'device-swinggate', // ZLB24S
  980: 'device-slidinggate', //ZNC1 CHANGE
  981: 'device-swinggate', // ZLX230P
  982: 'device-shutter', // ZC3N
  983: 'device-tapparella', // CHANGE
  984: 'device-barrier', // CHANGE
  985: 'device-barrier', // CHANGE
  986: 'device-barrier', // CHANGE
  987: 'device-barrier', // CHANGE
  988: 'device-garage', // CHANGE
  989: 'device-slidinggate', // CHANGE
  990: 'device-slidinggate', // CHANGE
  991: 'device-slidinggate', // CHANGE
  992: 'device-slidinggate', // CHANGE
  993: 'device-swinggate', // CHANGE
  994: 'device-swinggate', // CHANGE
  995: 'device-barrier', // CHANGE
  996: 'device-slidinggate', // CHANGE
  997: 'device-swinggate', // CHANGE
  998: 'device-swinggate', // CHANGE
  999: 'device-swinggate', // CHANGE*/
  0: 'gateway-domotic',  //  ETI/DOMO
  1: 'gateway-security',  //  001SIGRPRS/PXGPRS
  2: 'device-gateway-ethernet',  //  001UR042
  3: 'gateway-domotic',  //  ETI/DOMO XIP
  4: 'gateway-domotic',  //  ETI/MINISER XIP
  5: 'gateway-domotic',  //  ETI/SER XIP
  6: 'gateway-domotic',  //  DVC/IP
  7: 'termo',  //  TH/500
  8: 'termo',  //  TH/750
  9: 'device-gateway-gsm',  //  RGSM001
  10: 'device-subgateway',  //  RSLV001
  11: 'device-gateway-ethernet',  //  RETH001
  12: 'device-gateway-gsm',  //  RGSM001S
  13: 'termo',  //  TH/One
  14: 'device-gateway-gsm',  //  Gateway 4G radio
  15: 'device-gateway',  //  QBEDFSB1
  16: 'device-gateway',  //  QBEDFMB3
  17: 'device-gateway-gsm',  //  Gateway 4G standalone
  18: 'device-gateway',  //  QBEMFSB2
  19: 'gateway-security',  //  CENTRALE SICUREZZA PXC2
  20: 'termo',  //  TH/700
  21: 'input-output',  //  Virtual Device
  22: 'device-subgateway',  //  Modulo slave
  23: 'device-camekey',  //  Gateway Wifi
  24: 'virtual-input',  //  Input
  25: 'virtual-output',  //  Output
  26: 'input-output',  //  Inputs/Outputs
  27: 'derivate',  //  MTMA/Connect
  28: 'derivate',  //  XTS7 IP WIFI
  29: 'derivate',  //  PLXWIFI
  30: 'derivate',  //  MTMx/IP
  31: 'derivate',  //  XTS5
  32: 'derivate',  //  XVP
  33: 'derivate',  //  XTS7
  34: 'derivate',  //  PLX IP WIFI
  40: 'derivate',  //  MTMA/Connect US
  41: 'derivate',  //  LHSA 01
  42: 'derivate',  //  LHSV 01
  43: 'derivate',  //  LHSV 01 PLUS
  44: 'device-gateway',  //  TH/ONE GW
  45: 'termo',  //  TH/ONE BT
  51: 'device-barrier',  //  GARD4EZ
  52: 'device-barrier',  //  G5000
  53: 'device-barrier',  //  GARDPT
  54: 'device-barrier',  //  GARDPX
  55: 'device-barrier',  //  GARD8EZ
  56: 'device-garage',  //  VER PLUS
  57: 'input-output',  //  IORS485
  58: 'device-rbe',  //  RBE4
  59: 'device-tapparella',  //  VOILÀ
  60: 'device-slidinggate',  //  BXV
  61: 'device-slidinggate',  //  BXV Tall
  62: 'device-slidinggate',  //  BK
  63: 'device-slidinggate',  //  BXV Quick
  64: 'device-slidinggate',  //  BKV
  65: 'device-slidinggate',  //  BX
  66: 'device-swinggate',  //  FERNI (230V)
  67: 'device-swinggate',  //  FERNI (24V)
  68: 'device-swinggate',  //  FAST40 (230V)
  69: 'device-swinggate',  //  KRONO
  70: 'device-swinggate',  //  FROG J
  71: 'device-swinggate',  //  FROG (230V)
  72: 'device-swinggate',  //  FROG (24V)
  73: 'device-swinggate',  //  MYTO
  74: 'device-swinggate',  //  SuperFrog
  75: 'device-swinggate',  //  FAST40 (24V)
  76: 'device-swinggate',  //  F4000 (24V)
  77: 'device-swinggate',  //  AXI
  78: 'device-swinggate',  //  FTX
  79: 'device-swinggate',  //  AMICO (24V)
  80: 'device-swinggate',  //  AXO (230V)
  81: 'device-swinggate',  //  AXO (24V)
  82: 'device-swinggate',  //  ATI (230V)
  83: 'device-swinggate',  //  F4000 (230V)
  84: 'device-swinggate',  //  FROG PLUS
  85: 'device-turnstile',  //  STILE ONE
  86: 'device-turnstile',  //  XVIA
  87: 'device-turnstile',  //  SALOON40
  88: 'device-turnstile',  //  WING40
  89: 'device-swinggate',  //  AMICO (24V)
  90: 'device-swinggate',  //  AMICO (24V)
  91: 'device-barrier',  //  GARD GT4
  92: 'device-barrier',  //  GARD GT8
  93: 'device-swinggate',  //  ATI (24V)
  94: 'device-swinggate',  //  ATI (24V)
  95: 'device-swinggate',  //  AXO (24V)
  96: 'device-swinggate',  //  AXO (24V)
  97: 'device-swinggate',  //  ATS (24V)
  98: 'device-swinggate',  //  ATS (24V)
  99: 'device-swinggate',  //  FERNI (24V)
  100: 'device-swinggate',  //  FERNI (24V)
  101: 'device-swinggate',  //  FROG (24V)
  102: 'device-swinggate',  //  FROG (24V)
  103: 'device-swinggate',  //  AXI
  104: 'device-swinggate',  //  AXI
  105: 'device-swinggate',  //  FAST70 (24V)
  106: 'device-swinggate',  //  FAST70 (24V)
  107: 'device-swinggate',  //  FTX
  108: 'device-swinggate',  //  FTX
  109: 'device-swinggate',  //  STYLO
  110: 'device-swinggate',  //  STYLO
  111: 'device-slidinggate',  //  BKV Reversible
  112: 'device-slidinggate',  //  BXV Plus
  113: 'device-swinggate',  //  FROG X
  114: 'device-barrier',  //  LT4/LS4
  115: 'device-swinggate',  //  FERNI V (24V)
  116: 'device-swinggate',  //  F4000 (24V)
  117: 'device-swinggate',  //  FERNI V (24V)
  118: 'device-swinggate',  //  F4000 (24V)
  119: 'device-swinggate',  //  FAST70 (230V)
  120: 'device-swinggate',  //  FROG PLUS (230V)
  121: 'device-swinggate',  //  ATI (24V)
  122: 'device-swinggate',  //  ATS (24V)
  123: 'device-swinggate',  //  FERNI V (24V)
  124: 'device-swinggate',  //  FAST70 (24V)
  125: 'device-swinggate',  //  ATS
  126: 'device-swinggate',  //  FAST70
  127: 'device-swinggate',  //  F500
  128: 'device-turnstile',  //  TWS32MX
  129: 'device-slidinggate',  //  BKX
  130: 'device-barrier',  //  CAT
  131: 'device-rbe',  //  RBEPLUS
  132: 'device-shutter',  //  C-BX
  133: 'device-shutter',  //  C-BXK
  134: 'device-swinggate',  //  FROG (230V)
  135: 'device-swinggate',  //  KRONO
  136: 'device-swinggate',  //  ATI (230V)
  137: 'device-swinggate',  //  ATS
  201: 'device-tapparella',  //  VLR01SX
  202: 'device-swinggate',  //  A3006
  203: 'device-swinggate',  //  FST23DLS
  204: 'device-swinggate',  //  FST23DLS
  205: 'device-swinggate',  //  ATS30DGM
  206: 'device-slidinggate',  //  BXV06RGS
  207: 'device-barrier',  //  GGT40ACP
  208: 'device-slidinggate',  //  BXV10ABS
  209: 'device-swinggate',  //  F40230E
  210: 'device-barrier',  //  GPT40AGL
  211: 'device-swinggate',  //  KR510S
  212: 'device-swinggate',  //  A3024N
  213: 'device-swinggate',  //  FA40230
  214: 'device-swinggate',  //  FTX20DLC
  215: 'device-slidinggate',  //  BKV15AGS
  216: 'device-barrier',  //  GPX40MGP
  217: 'device-shutter',  //  C-BX
  218: 'device-swinggate',  //  FA40230
  219: 'device-slidinggate',  //  BX708RGS
  220: 'device-swinggate',  //  F4024EP
  221: 'device-barrier',  //  GLT60ACS
  222: 'device-swinggate',  //  FST23DLC
  223: 'device-swinggate',  //  ATS50DGM
  224: 'device-swinggate',  //  KR310D
  225: 'device-swinggate',  //  FST23DLS
  226: 'device-swinggate',  //  Generico230
  227: 'device-slidinggate',  //  BXV04AGF
  228: 'device-swinggate',  //  FROG-J
  229: 'device-swinggate',  //  A3024N
  230: 'device-slidinggate',  //  BKV25AGE
  231: 'device-barrier',  //  GGT80ACS
  232: 'device-shutter',  //  C-BXK
  233: 'device-swinggate',  //  A300A
  234: 'device-swinggate',  //  F4024E
  235: 'device-garage',  //  VER10DMS
  236: 'device-barrier',  //  GLS60RGS
  237: 'device-swinggate',  //  KR300D
  238: 'device-swinggate',  //  STYLO-RME
  239: 'device-swinggate',  //  FTX20DLC
  240: 'device-barrier',  //  GLT40AOS
  241: 'device-rbe',  //  RBE230 PLUS
  242: 'device-swinggate',  //  ATS30DGS
  243: 'device-swinggate',  //  ATS30AGR
  244: 'device-slidinggate',  //  BKS08AGS
  245: 'device-swinggate',  //  F4024EP
  246: 'device-swinggate',  //  FROG-A24E
  247: 'device-swinggate',  //  A5006
  248: 'device-swinggate',  //  A1824
  249: 'device-swinggate',  //  AX3024
  250: 'device-swinggate',  //  KR300S
  251: 'device-swinggate',  //  FA7024CB
  252: 'device-swinggate',  //  FTX20DLS
  253: 'device-swinggate',  //  F500
  254: 'device-slidinggate',  //  BKV25ALS
  255: 'device-barrier',  //  G4040EZT
  256: 'device-barrier',  //  GGT80RGS
  257: 'device-swinggate',  //  FROG-A
  258: 'device-swinggate',  //  FST23DLC
  259: 'device-swinggate',  //  FTX20DLC
  260: 'device-swinggate',  //  ATS50AGR
  261: 'device-swinggate',  //  ATS30DGM
  262: 'device-slidinggate',  //  BXV10AGT
  263: 'device-barrier',  //  GLT60ROS
  264: 'device-barrier',  //  GPT40AGS
  265: 'device-swinggate',  //  KR300D
  266: 'device-swinggate',  //  AXI25DGS
  267: 'device-slidinggate',  //  BKS18AGS
  268: 'device-slidinggate',  //  BXV06AGT
  269: 'device-barrier',  //  GLT60AX4
  270: 'device-rbe',  //  RBE4024
  271: 'device-swinggate',  //  A5000A
  272: 'device-slidinggate',  //  BX704AGS
  273: 'device-slidinggate',  //  BXV06AGS
  274: 'device-slidinggate',  //  BXV08AGS
  275: 'device-slidinggate',  //  BKV15ALS
  276: 'device-swinggate',  //  FROG-A
  277: 'device-swinggate',  //  FROG-J
  278: 'device-slidinggate',  //  BXV06AGE
  279: 'device-slidinggate',  //  BKV20RGS
  280: 'device-swinggate',  //  A1824
  281: 'device-swinggate',  //  F4024E
  282: 'device-barrier',  //  GGT40ACS
  283: 'device-barrier',  //  GLT60AOS
  284: 'device-swinggate',  //  FROG-X
  285: 'device-swinggate',  //  FROG-A24E
  286: 'device-swinggate',  //  FTX20DGC
  287: 'device-swinggate',  //  ATS30DGM
  288: 'device-slidinggate',  //  BXV04RGS
  289: 'device-slidinggate',  //  BKX08AGF
  290: 'device-barrier',  //  CAT1DAGS
  291: 'device-swinggate',  //  A5024N
  292: 'device-swinggate',  //  F510
  293: 'device-slidinggate',  //  BXV08ABS
  294: 'device-barrier',  //  GLS60AX4
  295: 'device-slidinggate',  //  BKV20ALS
  296: 'device-swinggate',  //  FE40230V
  297: 'device-swinggate',  //  FROG-MD
  298: 'device-swinggate',  //  A3000
  299: 'device-swinggate',  //  ATS50DGM
  300: 'device-slidinggate',  //  BKS12AGS
  301: 'device-barrier',  //  GLS40ACS
  302: 'device-barrier',  //  GGT80AX6
  303: 'device-swinggate',  //  AX71230
  304: 'device-slidinggate',  //  BXV10AGE
  305: 'device-swinggate',  //  F4024EP
  306: 'device-barrier',  //  G4040EZ
  307: 'device-swinggate',  //  FROG-AE
  308: 'device-swinggate',  //  FTX20DLC
  309: 'device-slidinggate',  //  BXV10AGF
  310: 'device-swinggate',  //  ATS30DGR
  311: 'device-swinggate',  //  ATS50DGM
  312: 'device-slidinggate',  //  BXV08RGS
  313: 'device-slidinggate',  //  BKS22AGE
  314: 'device-rbe',  //  RBE24 PLUS
  315: 'device-swinggate',  //  FE40230
  316: 'device-swinggate',  //  A5000A
  317: 'device-swinggate',  //  AXI25DGS
  318: 'device-swinggate',  //  FA4024
  319: 'device-swinggate',  //  AXI25DGS
  320: 'device-swinggate',  //  A1824
  321: 'device-swinggate',  //  FTX20DLS
  322: 'device-swinggate',  //  FE4024V
  323: 'device-swinggate',  //  ATS30DGR
  324: 'device-slidinggate',  //  BXV06ABS
  325: 'device-swinggate',  //  KR510S
  326: 'device-swinggate',  //  A5024N
  327: 'device-swinggate',  //  AXI25DGS
  328: 'device-swinggate',  //  FTX20DGS
  329: 'device-barrier',  //  GLT40AX4
  330: 'device-swinggate',  //  FE4024
  331: 'device-swinggate',  //  AXI20DGS
  332: 'device-swinggate',  //  STYLO-ME
  333: 'device-swinggate',  //  FTX20DGC
  334: 'device-swinggate',  //  FTX20DGS
  335: 'device-swinggate',  //  FROG-A24
  336: 'device-swinggate',  //  FTX20DGC
  337: 'device-swinggate',  //  ATS30AGS
  338: 'device-barrier',  //  GLS40AGS
  339: 'device-swinggate',  //  ATS50DGS
  340: 'device-barrier',  //  GGT40AX6
  341: 'device-swinggate',  //  A5024N
  342: 'device-swinggate',  //  AX312304
  343: 'device-swinggate',  //  AX412306
  344: 'device-swinggate',  //  KR310S
  345: 'device-swinggate',  //  A3024N
  346: 'device-swinggate',  //  ATS50AGR
  347: 'device-swinggate',  //  AX5024
  348: 'device-swinggate',  //  FST23DLS
  349: 'device-swinggate',  //  ATS30DGS
  350: 'device-swinggate',  //  ATS30AGS
  351: 'device-swinggate',  //  STYLO-RME
  352: 'device-swinggate',  //  Generico24
  353: 'device-slidinggate',  //  BXV04ABS
  354: 'device-barrier',  //  GGT40AX4
  355: 'device-swinggate',  //  FROG-AE
  356: 'device-slidinggate',  //  BXV08AGT
  357: 'device-slidinggate',  //  BKV15AGE
  358: 'device-tapparella',  //  VLR01DX
  359: 'device-swinggate',  //  ATS30DGS
  360: 'device-barrier',  //  GLS40AX4
  361: 'device-swinggate',  //  A3006
  362: 'device-swinggate',  //  AX3024
  363: 'device-swinggate',  //  FA7024
  364: 'device-swinggate',  //  FA7024
  365: 'device-swinggate',  //  ATS30AGM
  366: 'device-slidinggate',  //  BXV04AGE
  367: 'device-barrier',  //  GGT40RGS
  368: 'device-swinggate',  //  STYLO-ME
  369: 'device-swinggate',  //  ATS50DGS
  370: 'device-swinggate',  //  FTX20DGC
  371: 'device-swinggate',  //  FTX20DLS
  372: 'device-barrier',  //  GLT40ROS
  373: 'device-barrier',  //  GLS40RGS
  374: 'device-swinggate',  //  FE4024
  375: 'device-slidinggate',  //  BXV10AGS
  376: 'device-barrier',  //  GLS60ACS
  377: 'device-barrier',  //  GPX40MGS
  378: 'device-swinggate',  //  FROG-PM6
  379: 'device-swinggate',  //  KR310S
  380: 'device-swinggate',  //  KR510D
  381: 'device-swinggate',  //  AX5024
  382: 'device-swinggate',  //  A5000
  383: 'device-swinggate',  //  ATS50DGS
  384: 'device-slidinggate',  //  BXV10RGS
  385: 'device-swinggate',  //  FST23DLC
  386: 'device-swinggate',  //  FROG-J
  387: 'device-slidinggate',  //  BXV04AGT
  388: 'device-swinggate',  //  F4024E
  389: 'device-swinggate',  //  FST23DLC
  390: 'device-swinggate',  //  FTX20DGS
  391: 'device-swinggate',  //  FTX20DGS
  392: 'device-swinggate',  //  AX402306
  393: 'device-swinggate',  //  KR300S
  394: 'device-swinggate',  //  AXI20DGS
  395: 'device-swinggate',  //  AX5024
  396: 'device-swinggate',  //  FROG-X
  397: 'device-swinggate',  //  FROG-A24
  398: 'device-swinggate',  //  FA7024CB
  399: 'device-barrier',  //  G2080EZ
  400: 'device-swinggate',  //  FROG-A24E
  401: 'device-swinggate',  //  FTX20DLC
  402: 'device-slidinggate',  //  BKV20AGE
  403: 'device-swinggate',  //  FTX20DGS
  404: 'device-barrier',  //  GLS60AGS
  405: 'device-slidinggate',  //  BXV06AGF
  406: 'device-barrier',  //  GGT40AGP
  407: 'device-swinggate',  //  FA7024CB
  408: 'device-swinggate',  //  FTX20DLC
  409: 'device-swinggate',  //  ATS30DGM
  410: 'device-swinggate',  //  ATS50AGS
  411: 'device-swinggate',  //  AX302304
  412: 'device-swinggate',  //  A3024N
  413: 'device-swinggate',  //  AXI20DGS
  414: 'device-swinggate',  //  AX3024
  415: 'device-swinggate',  //  ATS30AGR
  416: 'device-swinggate',  //  ATS50AGM
  417: 'device-slidinggate',  //  BKV15RGS
  418: 'device-swinggate',  //  ATS50DGM
  419: 'device-barrier',  //  G5000
  420: 'device-barrier',  //  GPX40MXP
  421: 'device-swinggate',  //  A5024N
  422: 'device-swinggate',  //  A300A
  423: 'device-swinggate',  //  FE4024V
  424: 'device-barrier',  //  CAT1DACS
  425: 'device-rbe',  //  RBE4230
  426: 'device-swinggate',  //  FA7024
  427: 'device-swinggate',  //  FTX20DLS
  428: 'device-swinggate',  //  FE4024V
  429: 'device-slidinggate',  //  BKV20AGS
  430: 'device-swinggate',  //  A3000
  431: 'device-swinggate',  //  AXI20DGS
  432: 'device-barrier',  //  GLS40ABS
  433: 'device-barrier',  //  GPX40MGC
  434: 'device-swinggate',  //  ATS30DGS
  435: 'device-barrier',  //  GGT80AGS
  436: 'device-barrier',  //  GLT40ACS
  437: 'device-swinggate',  //  FROG-PM4
  438: 'device-swinggate',  //  FTX20DGC
  439: 'device-swinggate',  //  FE4024
  440: 'device-slidinggate',  //  BXV04AGS
  441: 'device-swinggate',  //  FROG-MS
  442: 'device-barrier',  //  GGT40RX4
  443: 'device-tapparella',  //  VLR02
  444: 'device-swinggate',  //  FA7024
  445: 'device-swinggate',  //  FTX20DLS
  446: 'device-swinggate',  //  ATS50DGS
  447: 'device-swinggate',  //  ATS30AGM
  448: 'device-garage',  //  VER13DMS
  449: 'device-swinggate',  //  KR510D
  450: 'device-swinggate',  //  MYTO-ME
  451: 'device-slidinggate',  //  BKS22AGS
  452: 'device-slidinggate',  //  BKV25AGS
  453: 'device-swinggate',  //  FTX20DLS
  454: 'device-swinggate',  //  ATS30DGR
  455: 'device-swinggate',  //  ATS50AGS
  456: 'device-slidinggate',  //  BX708AGS
  457: 'device-swinggate',  //  KR310D
  458: 'device-swinggate',  //  FA7024CB
  459: 'device-swinggate',  //  FTX20DGC
  460: 'device-swinggate',  //  FTX20DGS
  461: 'device-slidinggate',  //  BKS18RGS
  462: 'device-swinggate',  //  ATS50AGM
  463: 'device-barrier',  //  GGT40AGS
  464: 'device-swinggate',  //  ATS30DGR
  465: 'device-swinggate',  //  Generico24
  466: 'device-barrier',  //  GGT80AX4
  467: 'device-barrier',  //  GGT40UGS
  468: 'device-barrier',  //  GGT40UX4
  469: 'device-barrier',  //  GGT80UCS
  470: 'device-barrier',  //  GGT80UGS
  471: 'device-barrier',  //  GGT80UX4
  472: 'device-barrier',  //  GGT40UCS
  473: 'device-swinggate',  //  ATS30AGM
  474: 'device-swinggate',  //  AX312304
  475: 'device-swinggate',  //  KR300S
  476: 'device-swinggate',  //  FE40230
  477: 'device-swinggate',  //  KR510D
  478: 'device-swinggate',  //  A3000
  479: 'device-swinggate',  //  ATS50AGS
  480: 'device-swinggate',  //  Generico230
  481: 'device-swinggate',  //  KR310D
  482: 'device-swinggate',  //  A5000A
  483: 'device-swinggate',  //  FROG-A
  484: 'device-swinggate',  //  FE40230V
  485: 'device-swinggate',  //  ATS30AGR
  486: 'device-swinggate',  //  KR510S
  487: 'device-swinggate',  //  A3006
  488: 'device-swinggate',  //  ATS50AGM
  489: 'device-swinggate',  //  AX402306
  490: 'device-swinggate',  //  AX312304
  491: 'device-swinggate',  //  AX412306
  492: 'device-swinggate',  //  KR510S
  493: 'device-swinggate',  //  ATS50AGR
  494: 'device-swinggate',  //  AX302304
  495: 'device-swinggate',  //  AX71230
  496: 'device-swinggate',  //  FE40230
  497: 'device-swinggate',  //  FE40230V
  498: 'device-swinggate',  //  A5000A
  499: 'device-swinggate',  //  KR300D
  500: 'device-swinggate',  //  FROG-AE
  501: 'device-swinggate',  //  A3006
  502: 'device-swinggate',  //  AX412306
  503: 'device-swinggate',  //  A300A
  504: 'device-swinggate',  //  ATS30AGM
  505: 'device-swinggate',  //  KR300S
  506: 'device-swinggate',  //  KR310S
  507: 'device-swinggate',  //  FROG-A
  508: 'device-swinggate',  //  AX302304
  509: 'device-swinggate',  //  ATS30AGS
  510: 'device-swinggate',  //  FA40230
  511: 'device-swinggate',  //  FA40230
  512: 'device-swinggate',  //  ATS50AGS
  513: 'device-swinggate',  //  KR310S
  514: 'device-swinggate',  //  AX71230
  515: 'device-swinggate',  //  FROG-AE
  516: 'device-swinggate',  //  ATS50AGM
  517: 'device-swinggate',  //  AX402306
  518: 'device-swinggate',  //  KR310D
  519: 'device-swinggate',  //  A3000
  520: 'device-swinggate',  //  ATS50AGR
  521: 'device-swinggate',  //  ATS30AGR
  522: 'device-swinggate',  //  KR510D
  523: 'device-swinggate',  //  Generico230
  524: 'device-swinggate',  //  ATS30AGS
  525: 'device-swinggate',  //  A300A
  526: 'device-swinggate',  //  KR300D
  969: 'device-swinggate',  //  ZLX230S
  970: 'device-swinggate',  //  ZLX230M
  971: 'device-barrier',  //  ZL392D
  972: 'device-rbe',  //  RBEPLUS
  973: 'device-barrier',  //  ZN7D
  974: 'device-slidinggate',  //  ZBB2
  975: 'device-barrier',  //  ZL392C
  976: 'device-slidinggate',  //  ZN8REV
  977: 'input-output',  //  IORS485
  978: 'device-rbe',  //  RBE4
  979: 'device-swinggate',  //  ZLB24S
  980: 'device-slidinggate',  //  ZBC1
  981: 'device-swinggate',  //  ZLX230P
  982: 'device-shutter',  //  ZC3N
  983: 'device-tapparella',  //  ZVL2
  984: 'device-barrier',  //  ZL392
  985: 'device-barrier',  //  ZLB30A
  986: 'device-barrier',  //  ZLB30B
  987: 'device-barrier',  //  ZL39EX
  988: 'device-garage',  //  ZL57
  989: 'device-slidinggate',  //  ZN8
  990: 'device-slidinggate',  //  ZBKN
  991: 'device-slidinggate',  //  ZBX7N
  992: 'device-slidinggate',  //  ZN7V
  993: 'device-swinggate',  //  ZLX24M
  994: 'device-swinggate',  //  ZLX24S
  995: 'device-barrier',  //  ZL39A
  996: 'device-slidinggate',  //  ZN7
  997: 'device-swinggate',  //  ZM3
  998: 'device-swinggate',  //  ZLJ24
  999: 'device-swinggate',  //  ZL65

};

export const VIRTUAL_ICONS = [
  DeviceIcon.virtualdevice,
  DeviceIcon.alarm,
  DeviceIcon.audio,
  DeviceIcon.bulb,
  DeviceIcon.cameratvcc,
  DeviceIcon.carichi,
  DeviceIcon.carichi2,
  DeviceIcon.Rele,
  DeviceIcon.tapparella,
  DeviceIcon.termo,
  DeviceIcon.timers,
  DeviceIcon.automaticDoor1,
  DeviceIcon.barrier0,
  DeviceIcon.slidingGate0,
  DeviceIcon.swingGate1,
  DeviceIcon.shutter0,
  DeviceIcon.turnStile1
];

export const VIRTUAL_ICONS_VALUE = [
  { label: DeviceIcon.virtualdevice, value: DeviceIcon.virtualdevice },
  { label: DeviceIcon.alarm, value: DeviceIcon.alarm },
  { label: DeviceIcon.audio, value: DeviceIcon.audio },
  { label: DeviceIcon.bulb, value: DeviceIcon.bulb },
  { label: DeviceIcon.cameratvcc, value: DeviceIcon.cameratvcc },
  { label: DeviceIcon.carichi, value: DeviceIcon.carichi },
  //{label:DeviceIcon.carichi2, value:DeviceIcon.carichi2}, Same ICONE
  { label: DeviceIcon.Rele, value: DeviceIcon.Rele },
  { label: DeviceIcon.tapparella, value: DeviceIcon.tapparella },
  { label: DeviceIcon.termo, value: DeviceIcon.termo },
  { label: DeviceIcon.timers, value: DeviceIcon.timers },
  { label: DeviceIcon.automaticDoor1, value: DeviceIcon.automaticDoor1 },
  { label: DeviceIcon.barrier0, value: DeviceIcon.barrier0 },
  { label: DeviceIcon.slidingGate0, value: DeviceIcon.slidingGate0 },
  { label: DeviceIcon.swingGate1, value: DeviceIcon.swingGate1 },
  { label: DeviceIcon.garage, value: DeviceIcon.garage },
  { label: DeviceIcon.turnStile1, value: DeviceIcon.turnStile1 },
];

